<template>
  <div class="workshop">
    <app-Workshophero></app-Workshophero>
    <u-nav-wrap class="py-1">
      <unav :items="navItems" v-model="navItem" @input="filter"></unav>
      <!-- <usearch
        @input="searchCourse"
        v-model="search"
        @search="searchCourse"
        placeholder="Search by Name or Category"
      ></usearch> -->
    </u-nav-wrap>
    <div v-if="result.length < 1 && $store.state.loaded">
      <div class="text-md-center">
        <h1>No search results found</h1>
      </div>
    </div>
    <app-Workshop :WorkshopData="result"></app-Workshop>
  </div>
</template>

<script>
// @ is an alias to /src
import workshophero from '../components/workshops/workshop-hero'
import workshop from '../components/workshops/workshop'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'workshop',
  data() {
    return {
      search: '',
      navItem: '',
      navItems: ['All', 'Upcoming Workshops', 'Previous Workshops'],
      result: [],
    }
  },
  components: {
    appWorkshophero: workshophero,
    appWorkshop: workshop,
  },
  methods: {
    searchCourse(value) {
      let result = []
      result = this.WorkshopData.filter(
        (ws) => ws.name.includes(value) || ws.description.includes(value)
      )
      this.result.toLowerCase = result
    },
    filter(category) {
      if (category === 'All') {
        this.result = this.WorkshopData
      } else {
        let result = []
        this.WorkshopData.forEach((ws) => {
          if (this.isOver(ws.workshop_ts)) {
            if (category === 'Previous Workshops') {
              result.push(ws)
            }
          } else {
            if (category === 'Upcoming Workshops') {
              result.push(ws)
            }
          }
        })
        this.result.toLowerCase = result
      }
    },
    ...mapActions('WorkshopData', ['GET_WORKSHOPDATA']),
    isOver(wstime) {
      if (moment(wstime).unix() - moment().unix() > 0) {
        return false
      }
      return true
    },
  },
  computed: {
    ...mapGetters('WorkshopData', ['WorkshopData']),
  },
  async mounted() {
    const promise = this.GET_WORKSHOPDATA()
    await Promise.all([promise])
    this.Loaded()
    this.result = this.WorkshopData
  },
}
</script>
